import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'KYCPPI/Select');
};

export const Add = async (request) => {
    return PostAPI(request, 'KYCPPI/SenderRegistration');
}; 

export const VerifyOTP = async (request) => {
    return PostAPI(request, 'KYCPPI/SenderVerifyOTP');
};

export const ResendOTP = async (request) => {
    return PostAPI(request, 'KYCPPI/SenderResendOTP');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'KYCPPI/AddBeneficiary');
};

export const SelectBank = async (request) => {
    return PostAPI(request, 'DMTBank/Select');
};

export const SelectBeneficiary = async (request) => {
    return PostAPI(request, 'KYCPPI/SelectBeneficiary');
};

export const DeleteBeneficiary = async (request) => {
    return PostAPI(request, 'KYCPPI/DeleteBeneficiary');
};

export const MoneyTransfer = async (request) => {
    return PostAPI(request, 'KYCPPI/MoneyTransfer');
};

export const GetSplitAmountForTransactionKYCPPI = async (request) => {
    return PostAPI(request, 'KYCPPI/GetSplitAmountForTransactionKYCPPI');
};

export const GenerateOTPForSplitAmountKYCPPI = async (request) => {
    return PostAPI(request, 'KYCPPI/GenerateOTPForSplitAmountKYCPPI');
};
